import React, { ReactNode, useEffect, useRef } from "react";
import { useCampaignTestimonials } from "./hooks/useCampaignTestimonials";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";

const CampaignTestimonials = () => {
  const { t } = useTranslation();
  const sliderRef = useRef<Slider | null>(null);
  const sliderSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots: ReactNode) => (
      <div className="slider-nav">
        <button
          className="icon prev-icon"
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label={`${t("campaignTestimonials.previousSlide")}`}
        >
          <img src="/Assets/icons/arrow_left.png" aria-hidden="true" alt="" />
        </button>
        <ul className="slick-dots-wrapper">{dots}</ul>
        <button
          className="icon prev-icon"
          onClick={() => sliderRef.current?.slickNext()}
          aria-label={`${t("campaignTestimonials.nextSlide")}`}
        >
          <img src="/Assets/icons/arrow_right.png" aria-hidden="true" alt="" />
        </button>
      </div>
    ),
  };

  const { testimonials, getCampaignTestimonials, loading } =
    useCampaignTestimonials();

  useEffect(() => {
    getCampaignTestimonials();
  }, []);

  return (
    <>
      <Slider
        ref={(slider) => {
          sliderRef.current = slider;
        }}
        {...sliderSettings}
      >
        {testimonials &&
          testimonials.map((testimonial) => {
            return (
              <div key={testimonial.personDetails} className="inner-content">
                <div className="testimonial-image-wrapper">
                  <img
                    className="testimonial-image"
                    src={testimonial.image}
                    alt={testimonial.altText}
                  />
                </div>
                <p className="testimonial-text">
                  {testimonial.testimonialText}
                </p>
                <p className="testimonial-person">
                  {testimonial.personDetails}
                </p>
              </div>
            );
          })}
      </Slider>
    </>
  );
};

export default CampaignTestimonials;
